import { useState } from "react";
import { Button, Card, List, Typography } from "antd";
import AddIssueKindProblemModal from "./components/AddIssueKindProblemModal";
import Item from "./components/Item";
import QuestionMarkTooltip from "components/QuestionMarkTooltip";

const IssueKindProblems = ({ issue_kind_id, data, refetch }) => {
  const [is_open_add_comment_modal, setIsOpenAddIssueKindProblemModal] =
    useState(false);

  return (
    <Card
      className="m-b-20"
      title={
        <>
          Najczęściej zgłaszane problemy{" "}
          {data?.length > 0 ? `(${data.length})` : ""}{" "}
          <QuestionMarkTooltip
            text="Wyświetlane pod formularzem jako pola wyboru w celu podpowiedzi
          klientowi o typie problemu."
          />
        </>
      }
      styles={{
        body: {
          padding: "0 24px",
          minHeight: 180,
          maxHeight: 180,
          overflowY: "auto",
        },
      }}
      extra={
        <Button
          type="primary"
          onClick={() => setIsOpenAddIssueKindProblemModal(true)}
        >
          Dodaj
        </Button>
      }
    >
      <Typography style={{ margin: "10px 0" }}>
        <Typography.Text type="secondary"></Typography.Text>
      </Typography>
      {is_open_add_comment_modal && (
        <AddIssueKindProblemModal
          issue_kind_id={issue_kind_id}
          refetch={refetch}
          handleClose={() => setIsOpenAddIssueKindProblemModal(false)}
        />
      )}
      <List
        itemLayout="horizontal"
        dataSource={data}
        renderItem={(item, index) => (
          <Item
            {...item}
            refetch={refetch}
            is_first={index === 0}
            is_last={index === data?.length - 1}
          />
        )}
      />
    </Card>
  );
};

export default IssueKindProblems;
